import type { RepositoryDTO } from "features/types/repository";
import { useLegacyCsbApi } from "hooks/api/useLegacyCsbApi";

export type CreateRepositoryFnPayload = {
  name: string;
  organization: string;
  isPrivate: boolean;
};

export type CreateRepositoryFn = (
  params: CreateRepositoryFnPayload,
) => Promise<RepositoryDTO>;

export function useCreateRepository() {
  return useLegacyCsbApi<CreateRepositoryFn>((api) => {
    return ({ organization, name, isPrivate }) => {
      return api.rest.post<RepositoryDTO>({
        path: `/v1/github/repo`,
        data: {
          owner: organization,
          repo: name,
          private: isPrivate,
        },
      });
    };
  });
}
